module.exports = __webpack_public_path__ + "static/media/reset.a1f9d7ec.svg";